<template>
  <div v-show="false" class="user-profile">
    <div v-if="user" class="profile-content">
      <div class="profile-header">
        <img :src="user.imageUrl" alt="Profile" class="profile-image" />
        <h2>{{ user.fullName }}</h2>
      </div>
      <div class="profile-details">
        <p>
          <strong>Email:</strong> {{ user.primaryEmailAddress?.emailAddress }}
        </p>
        <p>
          <strong>{{ $t("auth.username") }}</strong> {{ user.username }}
        </p>
      </div>
      <div class="profile-actions">
        <button class="btn btn-primary mr-2" @click="openProfileModal">
          {{ $t("auth.editProfile") }}
        </button>
        <button class="btn btn-danger" @click="signOut">
          {{ $t("auth.signOut") }}
        </button>
      </div>
    </div>
    <div v-else>
      <button class="btn btn-primary" @click="signIn">
        {{ $t("auth.signIn") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserProfile",
  data() {
    return {
      user: null,
    };
  },
  async created() {
    const clerk = this.$getClerk();
    if (clerk) {
      this.user = clerk.user;
      clerk.addListener(({ user }) => {
        this.user = user;
      });
    }
  },
  methods: {
    async signIn() {
      const clerk = this.$getClerk();

      if (clerk) {
        await clerk.openSignIn();
      }
    },

    async signOut() {
      const clerk = this.$getClerk();

      if (clerk) {
        await clerk.signOut();
      }
    },

    async openProfileModal() {
      const clerk = this.$getClerk();

      if (clerk) {
        await clerk.openUserProfile();
      }
    },
  },
};
</script>

<style scoped>
.user-profile {
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
}

.profile-header {
  text-align: center;
  margin-bottom: 20px;
}

.profile-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-bottom: 10px;
}

.profile-details {
  margin-bottom: 20px;
}

.profile-details p {
  margin: 10px 0;
}

.profile-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
}
</style>
